import * as Types from '../../../__generated__/schema';

import { ActorTeaserAPIToken, ActorTeaserUser } from './ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from './ActorTeaser.generated';
export type RuleSummary = Pick<
  Types.Rule,
  | 'id'
  | 'description'
  | 'baseDetection'
  | 'userOverrides'
  | 'displayName'
  | 'isSimpleDetection'
  | 'logTypes'
  | 'scheduledQueries'
  | 'threshold'
  | 'simpleDetectionBody'
  | 'outputIds'
  | 'managed'
  | 'parentId'
  | 'runbook'
  | 'reference'
  | 'severity'
  | 'tags'
  | 'dedupPeriodMinutes'
  | 'createdAt'
  | 'createdByExternal'
  | 'lastModified'
  | 'enabled'
  | 'summaryAttributes'
  | 'analysisType'
  | 'createAlert'
  | 'specVersion'
  | 'filePath'
> & {
  fullScheduledQueries?: Types.Maybe<Array<Pick<Types.SavedQuery, 'id'>>>;
  createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
  lastModifiedBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
};

export const RuleSummary = gql`
  fragment RuleSummary on Rule {
    id
    description
    baseDetection
    userOverrides
    displayName
    isSimpleDetection
    logTypes
    scheduledQueries
    fullScheduledQueries {
      id
    }
    threshold
    simpleDetectionBody
    outputIds
    managed
    parentId
    runbook
    reference
    severity
    tags
    dedupPeriodMinutes
    createdAt
    createdByExternal
    createdBy {
      ...ActorTeaser
    }
    lastModified
    lastModifiedBy {
      ...ActorTeaser
    }
    enabled
    summaryAttributes
    analysisType
    createAlert
    specVersion
    filePath
  }
  ${ActorTeaser}
`;
